// extracted by mini-css-extract-plugin
export default {"IsDragging":"_IsDragging--hH7c4"};